<template>
  <v-form @submit.prevent="handleSubmit">
    <ValidationObserver ref="form" v-slot="{ invalid }">
      <v-card :loading="loading">
        <v-toolbar elevation="0">
          <v-toolbar-title>{{
            form.id ? form.nome : "Novo produto"
          }}</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-btn @click="handleCancel()" icon :disabled="submitting">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-text-field label="Código" :value="form.id" disabled></v-text-field>

          <ValidationProvider
            name="nome"
            rules="required|max:100"
            v-slot="{ errors }"
          >
            <v-text-field
              v-model="form.nome"
              label="Nome"
              name="nome"
              autofocus
              counter="100"
              :error-messages="errors"
              :disabled="loading || submitting"
            ></v-text-field>
          </ValidationProvider>

          <ValidationProvider
            name="marca"
            rules="required|max:45"
            v-slot="{ errors }"
          >
            <v-text-field
              v-model="form.marca"
              label="Marca"
              name="marca"
              counter="45"
              :error-messages="errors"
              :disabled="loading || submitting"
            ></v-text-field>
          </ValidationProvider>

          <ValidationProvider name="modelo" rules="max:45" v-slot="{ errors }">
            <v-text-field
              v-model="form.modelo"
              label="Modelo"
              counter="45"
              :error-messages="errors"
              :disabled="loading || submitting"
            ></v-text-field>
          </ValidationProvider>

          <ValidationProvider
            name="preco_venda"
            rules="required|min_value:0.01"
            v-slot="{ errors }"
          >
            <vuetify-money
              v-model="form.preco_venda"
              name="preco_venda"
              label="Preço de venda"
              :options="money_options"
              :error-messages="errors"
              :disabled="loading || submitting"
            ></vuetify-money>
          </ValidationProvider>
          <ValidationProvider
            name="min_preco_venda"
            :rules="{
              required: true,
              max_value: form.preco_venda,
              min_value: 0.0
            }"
            v-slot="{ errors }"
          >
            <vuetify-money
              v-model="form.min_preco_venda"
              name="min_preco_venda"
              label="Menor preço de venda"
              :options="money_options"
              :error-messages="errors"
              :disabled="loading || submitting"
            ></vuetify-money>
          </ValidationProvider>

          <v-row>
            <v-col>
              <ValidationProvider
                name="preco_custo"
                rules="min_value:0.00"
                v-slot="{ errors }"
              >
                <vuetify-money
                  v-model="form.preco_custo"
                  name="preco_custo"
                  label="Preço de custo"
                  :options="money_options"
                  :error-messages="errors"
                  :disabled="loading || submitting"
                ></vuetify-money>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-alert v-if="preco_custo_alert" type="warning" text>
            Tem certeza que o preço de venda é inferior ao preço de custo?
          </v-alert>

          <ValidationProvider
            name="unidade_medida"
            :rules="{
              required: true
            }"
            v-slot="{ errors }"
          >
            <v-autocomplete
              v-model="form.unidade_medida"
              label="Unidade de medida"
              :items="unities"
              item-value="name"
              item-text="label"
              :disabled="loading || submitting"
              name="unidade_medida"
              :error-messages="errors"
            >
            </v-autocomplete>
          </ValidationProvider>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="handleCancel()" text :disabled="submitting"
            >Cancelar</v-btn
          >
          <v-btn
            type="submit"
            color="red"
            dark
            :loading="submitting"
            :disabeld="invalid || loading"
            >Salvar</v-btn
          >
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-form>
</template>

<script>
import { create, update, show } from "@/services/products";

export default {
  name: "product-form",
  props: ["seed"],
  data: () => ({
    form: {
      preco_venda: 0,
      preco_custo: 0,
      min_preco_venda: 0
    },
    submitting: false,
    loading: false,
    money_options: {
      locale: "pt-BR",
      prefix: "R$",
      suffix: "",
      length: 11,
      precision: 2
    },
    unities: [
      { header: "Área" },
      { name: "m²", label: "m2 - Metro quadrado" },
      { name: "cm²", label: "cm2 - Centímetro quadrado" },
      { divider: true },
      { header: "Comprimento" },
      { name: "m", label: "m - Metro" },
      { name: "cm", label: "cm - Centímetro" },
      { divider: true },
      { header: "Embalagem" },
      { name: "UN", label: "UN - Unidade" },
      { name: "CT", label: "CT - Cartela" },
      { name: "CX", label: "CX - Caixa" },
      { name: "DZ", label: "DZ - Duzia" },
      { name: "GS", label: "GS - Grosa" },
      { name: "PA", label: "PA - Par" },
      { name: "PÇ", label: "PÇ - Peça" },
      { name: "PR", label: "PR - Par" },
      { name: "PT", label: "PT - Pacote" },
      { name: "RL", label: "RL - Rolo" },
      { name: "lata", label: "LATA - Lata" },
      { divider: true },
      { header: "Peso" },
      { name: "kg", label: "kg - Kilograma" },
      { name: "g", label: "g - Grama" },
      { name: "SC60", label: "SC60 - Saca 60Kg" },
      { divider: true },
      { header: "Volume" },
      { name: "l", label: "l - Litro" },
      { name: "m³", label: "m3 - Metro cúbico" },
      { name: "ml", label: "ml - Mililitro" },
      { name: "gal", label: "gal - Galão" }
    ]
  }),
  methods: {
    handleCancel() {
      this.resetForm();
      this.$emit("cancel");
    },
    resetForm() {
      this.form = {
        preco_venda: 0,
        min_preco_venda: 0
      };
      this.$refs.form.reset();
      this.$emit("cleared");
    },
    async handleSubmit() {
      const validation = await this.$refs.form.validate();
      if (!validation) return;

      this.submitting = true;

      try {
        const response = this.form.id
          ? await update(this.form.id, { ...this.form })
          : await create({ ...this.form });

        this.resetForm();
        this.$emit("submitted", response);
      } catch (error) {
        this.$store.commit("sendMessage", {
          text: "Falha ao salvar informações",
          color: "red"
        });
      } finally {
        this.submitting = false;
      }
    },
    async getItem(id) {
      this.loading = true;
      try {
        const response = await show(id);
        this.form = response;
      } catch (error) {
        this.$store.commit("sendMessage", {
          text: "Falha ao carregar informações",
          color: "red"
        });
      } finally {
        this.loading = false;
      }
    }
  },
  created() {
    if (this.seed) {
      this.form = { ...this.seed };
    }
  },
  watch: {
    seed: async function(value) {
      if (value) {
        this.form = { ...value };
      }
    }
  },
  computed: {
    user: function() {
      return this.$store.getters.getUser;
    },
    preco_custo_alert: function() {
      if (
        !this.form.preco_custo ||
        !this.form.min_preco_venda ||
        !this.form.preco_venda
      )
        return false;

      const preco_custo = Number.parseFloat(this.form.preco_custo);
      const preco_venda = Number.parseFloat(this.form.preco_venda);
      const min_preco_venda = Number.parseFloat(this.form.min_preco_venda);

      return preco_custo > preco_venda || preco_custo > min_preco_venda;
    }
  }
};
</script>
